import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  division: null,
  businessUnit: null,
  businessLine: null,
};
